import script from "./CardFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardFooter.vue?vue&type=script&setup=true&lang=ts"

import "./CardFooter.vue?vue&type=style&index=0&id=cece1422&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cece1422"]])

export default __exports__